module.exports = __webpack_public_path__ + "static/img/18.fac01044.png";